import * as React from "react";
const SvgFiRrMercury = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 10a8 8 0 0 0-4.126-6.997 8 8 0 0 0 1.725-1.29A1 1 0 0 0 16.198.287 5.97 5.97 0 0 1 12 2 5.96 5.96 0 0 1 7.802.286a1 1 0 0 0-1.401 1.428 8 8 0 0 0 1.725 1.289A8.01 8.01 0 0 0 4 10c0 4.073 3.059 7.444 7 7.938V20h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-2.062c3.941-.494 7-3.865 7-7.938M6 10c0-3.31 2.691-6 6-6s6 2.69 6 6-2.691 6-6 6-6-2.691-6-6"
    />
  </svg>
);
export default SvgFiRrMercury;
